<template>
    <div>
        <multiselect
            :select-label="select_label"
            :deselect-label="deselect_label"
            v-model="languages"
            :options="options"
            :multiple="multiple"
            label="language"
            track-by="language"
            :placeholder="placeholder"
            @select="addLanguage"
            @tag="addLanguage"
            @remove="removeLanguage"
            :disabled="disabled"
        >
            <template #tag="{ option, remove }">
                <span class="d-flex align-items-center multiselect__tag">
                    <span>
                        <div v-if="option.language == 'en' || option.language == 'us'">
                            <flag iso="us" />
                        </div>
                        <div v-if="option.language == 'es' || option.language == 'sp'">
                            <flag iso="es" />
                        </div>
                        <div v-if="!option.language || option.language == ''">
                            N/A
                        </div>
                    </span>

                    <span class="text-uppercase">{{ option.language }}</span>

                    <a tabindex="1" class="multiselect__tag-icon text-white" @click="remove(option)"></a>
                </span>
            </template>
            <template #singleLabel="{ option }">
                <span class="d-flex align-items-center">
                    <div class="mr-1">
                        <span v-if="option.language == 'en' || option.language == 'us'">
                            <flag iso="us" />
                        </span>
                        <span v-if="option.language == 'es' || option.language == 'sp'">
                            <flag iso="es" />
                        </span>
                        <div v-if="!option.language || option.language == ''">
                            N/A
                        </div>
                    </div>
                    <div class="text-uppercase">{{ option.language }}</div>
                </span>
            </template>
            <template #option="{ option }">
                <div class="option__desc">
                    <span class="d-flex align-items-center option__title">
                        <div class="mr-1">
                            <span v-if="option.language == 'en' || option.language == 'us'">
                                <flag iso="us" />
                            </span>
                            <span v-if="option.language == 'es' || option.language == 'sp'">
                                <flag iso="es" />
                            </span>
                            <div v-if="!option.language || option.language == ''">
                                N/A
                            </div>
                        </div>
                        <div class="text-uppercase">{{ option.language }}</div>
                    </span>
                </div>
            </template>
        </multiselect>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({}),
    props: [
        'select_label',
        'deselect_label',
        'value',
        'options',
        'multiple',
        'disabled',
    ],
    components: {},
    computed: {
        languages: {
            get () {
                return this.value
            },
            set () {}
        },
        placeholder () {
            let placeholder = null

            if (this.multiple) {
                placeholder = 'Languages'
            } else {
                placeholder = 'Language'
            }

            return placeholder
        }
    },
    methods: {
        addLanguage (new_language) {
            this.$emit('add', new_language)
        },
        removeLanguage (language) {
            this.$emit('remove', language)
        }
    }
}
</script>
